export default "__VITE_ASSET__CbgIJayx__"